import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'printStringReplace'
})
export class PrintStringReplacePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value) {
      return value.replace(/[&,()%]/g, '');
    }
    return '';
  }

}
